import React, { useCallback, useEffect, useState } from 'react';
import _ from 'lodash';
import { useSelector } from 'react-redux';
import { useHistory, useLocation } from 'react-router-dom';
import { useLastLocation } from 'react-router-last-location';

import { TYPE, URL } from '../../../constant';
import { getStageCodeByGrade } from '../../../utils/utilityEtc';
import { stageListAPI } from '../../../api/learningThemaAPI';
import {
  useLearningBtn, useLearningHistory,
  useLoading, useUserInfo, useConceptCheckPlayer
} from '../../../hooks';

import StageItem from './StageItem';
import ConceptCheckPlayerBox from '../../common/iframe/ConceptCheckPlayerBox';


function StageList({ thmaCd, onScroll }) {
  const lastLocaction = useLastLocation();
  const history = useHistory();
  const location = useLocation();
  
  const { info } = useUserInfo();
  const { learningHistoryInfo } = useLearningHistory();
  const { setLoading, clearLoading } = useLoading();
  const [list, setList] = useState([]);
  const [defaultAiMsgView, setDefaultAiMsgView] = useState(true);
  const [goLearning] = useLearningBtn();  // 학습하기
  const [, setConceptPopup] = useConceptCheckPlayer();  // 개념확인 팝업
  const deviceType = useSelector(state => state.deviceInfo.type);

  useEffect(() => {
    const tooltipBoxs = document.getElementsByClassName('tooltip-def tooltipBox active');

    setTimeout(() => {
      if (tooltipBoxs && tooltipBoxs.length > 1) {
        tooltipBoxs[0].style.display = 'none';
      }
    })
    
  })

  useEffect(() => {
    stageListAPICall(thmaCd)

    

    return () => {
      // thmaCd코드가 바뀌면 aimessage 말풍선 팝업 false
      setDefaultAiMsgView(false);
    }
  }, [thmaCd]);


  useEffect(() => {
    if (list.length === 0) return;
    const lastStageDom = document.getElementById("lastStage");
    const aiStageDom = document.getElementById('aiStage');
    const activeBtnDom = document.getElementsByClassName("btn-tab-active");
    const defaultStageDom = document.getElementsByClassName("defaultStage")[0];

    if (activeBtnDom) {
      if (activeBtnDom[0]) activeBtnDom[0].focus();
      
    }
    if (_.isEqual(lastLocaction?.pathname, URL.COURSE_LEARNING.AI_DIAGNOSIS_TEST.RESULT)) {
      if (defaultAiMsgView) {
        if (aiStageDom) aiStageDom.scrollIntoView(true);
        else if (lastStageDom) lastStageDom.scrollIntoView(true);
        
      }
    } else {
      if (lastStageDom) lastStageDom.scrollIntoView(true);
      else if (defaultStageDom) {
        if (learningHistoryInfo?.isLastLearningStage !== 'Y') {
          defaultStageDom.scrollIntoView(true);
        }
      }
      // aimessage 말풍선 팝업 false
      setDefaultAiMsgView(false);
    }
    document.getElementById('scrollingBox').scrollTop -= deviceType.type === TYPE.DEVICE.PC ? 90 : 80;
    
  }, [list])

  const stageListAPICall = useCallback(async (thmaCd, birth) => {
    setLoading({ isShowSpinner: true, spinnerType: '1' });
    try {
      const { locale, learnerId, learnerBirth } = info;
      const data = await stageListAPI({
        locale, learnerId, thmaCd
      });
      // default로 지정한 나이, 대주제, 소주제 값
      const defaultStgCd = getStageCodeByGrade(birth ? birth : learnerBirth);
      // stepNm별로 그룹핑
      const temp = _.chain(data.resp)
        .groupBy('stepNm')
        .toPairs()
        .map((item) => {  
          if (defaultStgCd?.age) {
            const defaultStgCd_index = _.findIndex(item[1], { stgCd: defaultStgCd.stgCd });
            // default 소주제값 표시
            if (defaultStgCd_index > -1) {
              item[1][defaultStgCd_index].defaultStgCdYN = 'Y'
            }
          }

          return {
            stepNm: item[0],
            items: item[1]
          }
        })
        .value();
      
      setList(temp);

    } catch (error) {
      
    } finally {
      clearLoading();
    }
  }, [thmaCd, list]);

  const handleLearningBtn = (item) => {

    let pathname = `${URL.LEARNING.RESULT}`;

    if (item.lrnEndDt === null || item.lrnEndDt === '' || item.lrnEndDt === undefined) {
      goLearning({
        stage: item.stgCd,
        lrnEntyScnCd: TYPE.LEARNING.TOPIC,
        learningEntryType: TYPE.LEARNING_ENTRY.THMA
      });
      return;
    }

    history.push({
      pathname,
      state: {
        stgCd: item.stgCd
      }
    });
  }

  if (list.length === 0) return <div></div>;

  return (
    <React.Fragment>
      <ConceptCheckPlayerBox />
      <div
        className="container scrollingBox"
        id="scrollingBox"
        onScroll={onScroll}
      >
        <div className="inner">
          <div
            className="scrolling-cont"
            id="scrolling-cont"
          >
            {
              list.map((gItem, gIndex) => (
                <div className="sl-section" key={gIndex}>
                  <div className="sl-section_head">
                    <h2>{gItem.stepNm}</h2>
                  </div>
                  <div className="sl-section_body">
                    <ul className="sl-section_list gm">
                      {
                        gItem.items.map((sItem, index) => (
                          <StageItem
                            key={index}
                            item={sItem}
                            btnType={location.state}
                            defaultAiMsgView={defaultAiMsgView}
                            handleLearningBtn={handleLearningBtn}
                            setConceptPopup={setConceptPopup}
                            stageListAPICall={stageListAPICall}
                          />
                        ))
                      }
                    </ul>
                  </div>
                </div>
              ))
            }
          </div>
        </div>
      </div>
    </React.Fragment>
  );
}

export default StageList;
